import { Action } from 'redux';
import { FUTURE } from 'src/modules/common/types/Future';
import { PROJECT_LIST_EXPORT_ONE } from 'src/modules/project-list/actions/ProjectListActions';
import { ProjectListState } from 'src/modules/project-list/types/ProjectListState';

export function projectListExportingReducer(state: ProjectListState, action: Action): ProjectListState {
  if (PROJECT_LIST_EXPORT_ONE.isPending(action)) {
    return {
      ...state,
      exporting: {
        project: action.meta,
        status: FUTURE.pending(),
      },
    };
  }
  if (PROJECT_LIST_EXPORT_ONE.isSuccess(action)) {
    return {
      ...state,
      exporting: {
        project: action.meta,
        status: FUTURE.success(undefined),
      },
    };
  }
  if (PROJECT_LIST_EXPORT_ONE.isFailure(action)) {
    return {
      ...state,
      exporting: {
        project: action.meta,
        status: FUTURE.failure(action.data),
      },
    };
  }

  return state;
}
